import React from 'react';
import { Spin } from 'antd';
// don't alias styles, it generates false positives in css-modules/no-undef-class
// import style from '~onboarding-pages/style.module.scss';
import style from '../../style.module.scss';
import { Section } from '~components/form-fields/section';

interface OnboardingSectionProps {
    title: string;
    isLoading: boolean;
    children: React.ReactNode;
}

export function OnboardingSection(props: OnboardingSectionProps) {
    return (
        <Section className={style.section_container} noCard>
            <div className={style.main_container}>
                <div className={style.box_container}>
                    <div className={`h5_bold ${style.section_title}`}>
                        {props.title}
                    </div>
                    {props.isLoading ? (
                        <Spin />
                    ) : (
                        <div className={style.row}>{props.children}</div>
                    )}
                </div>
            </div>
        </Section>
    );
}
